<template>
    <div>
      <v-row>
        <v-col
          cols="12"
          md="6">
          <v-card
            flat
            class="mb-6"
            style="border: 2px dashed #e0e0e0; border-radius: 10px;">
            <v-card-text>
              <ValidationProvider 
                name="Nomor Surat" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nomor Surat
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. SRT/PRK/20240102/0001"
                  hide-details
  
                  v-model="form.number"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Surat {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="form.number !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
  
              <ValidationProvider 
                name="Tujuan Penerima" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Tujuan Penerima
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  
                  placeholder="Contoh. John Doe"
                  hide-details
  
                  v-model="form.for"
                  :success="valid"
                  :error-messages="errors"
                  required
                  class="mb-3"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tujuan Penerima {{ errors[0] }}
                      </v-tooltip>
                    </div>
  
                    <div v-if="form.for !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-card-text>
          </v-card>

          <ValidationProvider 
            name="Nama File" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nama File
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Surat Menyurat"
              hide-details
  
              v-model="form.title"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nama File {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.title !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider
            name="Unit" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Unit
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>

            <v-autocomplete
              filled
              rounded
              dense
              :color="set_color"
              hide-details
              placeholder="Contoh. UMB Boga"

              :loading="process.unit"
              
              :items="units"
              item-value="name"
              item-text="name"
              :item-color="set_color"

              v-model="form.template_meta_json_object.unit"
              :success="form.template_meta_json_object.unit !== '' && valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Unit {{ errors[0] }}
                  </v-tooltip>
                </div>

                <div v-if="form.template_meta_json_object.unit !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-autocomplete>
          </ValidationProvider>
  
          <div>
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Tanggal
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
  
            <v-menu
              ref="tanggal"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.tanggal">
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider 
                  name="Tanggal" 
                  rules="required"
                  v-slot="{ errors, valid }">
                  <v-text-field
                    readonly
                    filled
                    rounded
                    dense
                    :color="set_color"
                    placeholder="Pilih Tanggal"
                    hide-details
                    clearable
  
                    @click:clear="form.template_meta_json_object.tanggal = null;"
                    v-on="on"
                    v-bind="attrs"
  
                    v-model="form.template_meta_json_object.tanggal"
                    :success="form.template_meta_json_object.tanggal !== null && valid"
                    :error-messages="errors"
                    class="mb-6"
                    style="border-radius: 10px; width: 40%;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Tanggal {{ errors[0] }}
                        </v-tooltip>
                      </div>
  
                      <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </template>
  
              <v-date-picker 
                :color="set_color"
                v-model="form.template_meta_json_object.tanggal"
                @input="picker.tanggal = false">
              </v-date-picker>
            </v-menu>
          </div>
  
          <ValidationProvider 
            name="Lampiran" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Lampiran
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. 1 Lembar"
              hide-details
  
              v-model="form.template_meta_json_object.lampiran"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px; width: 50%;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Lampiran {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.lampiran !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>   
  
          <ValidationProvider 
            name="Perihal" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Perihal
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Penawaran Produk"
              hide-details
  
              v-model="form.template_meta_json_object.hal"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px; width: 70%;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Hal {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.hal !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>  
  
          <div>
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Bulan
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
  
            <v-menu
              ref="tanggal"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.tanggal_mulai">
              <template v-slot:activator="{ on, attrs }">
                <ValidationProvider 
                  name="Bulan" 
                  rules="required"
                  v-slot="{ errors, valid }">
                  <v-text-field
                    readonly
                    filled
                    rounded
                    dense
                    :color="set_color"
                    placeholder="Pilih Bulan"
                    hide-details
                    clearable
  
                    @click:clear="form.template_meta_json_object.bulan = null;"
                    v-on="on"
                    v-bind="attrs"
  
                    v-model="form.template_meta_json_object.bulan"
                    :success="form.template_meta_json_object.bulan !== null && valid"
                    :error-messages="errors"
                    class="mb-6"
                    style="border-radius: 10px; width: 40%;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Bulan {{ errors[0] }}
                        </v-tooltip>
                      </div>
  
                      <div v-if="form.template_meta_json_object.bulan !== null && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </template>
  
              <v-date-picker 
                :color="set_color"
                type="month"
                v-model="form.template_meta_json_object.bulan"
                @input="picker.tanggal_mulai = false">
              </v-date-picker>
            </v-menu>
          </div>
  
          <ValidationProvider 
            name="Jumlah Karyawan" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Jumlah Karyawan
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. 2 Orang"
              hide-details
  
              v-model="form.template_meta_json_object.jumlah_karyawan"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Jumlah Karyawan {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.jumlah_karyawan !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Deskripsi Pekerjaan" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Rekening Debet
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Rekening Debet"
              hide-details
              type="number"
  
              v-model="form.template_meta_json_object.no_rekening"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Rekening Debet {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.no_rekening !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Nama Rekening Debet" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Nama Rekening Debet
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Nama Rekening Debet."
              hide-details
  
              v-model="form.template_meta_json_object.nama_rekening"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Nama Rekening Debet {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.nama_rekening !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Total Nominal Transaksi" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Total Nominal Transaksi
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-currency-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Total Total Nominal Transaksi"
              hide-details
  
              v-model="form.template_meta_json_object.total_transaksi"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Total Nominal Transaksi {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.total_transaksi !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-currency-field> 
          </ValidationProvider>
  
          <ValidationProvider 
            name="Catatan" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Catatan
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. catatan"
              hide-details
  
              v-model="form.template_meta_json_object.catatan"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Catatan {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.catatan !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
  
          <ValidationProvider 
            name="Manager Unit Bisnis" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Manager Unit Bisnis
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Manager Unit Bisnis"
              hide-details
  
              v-model="form.template_meta_json_object.nama_manager"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Manager Unit Bisnis {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.nama_manager !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Bendahara Unit Bisnis" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Bendahara Unit Bisnis
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Bendahara Unit Bisnis"
              hide-details
  
              v-model="form.template_meta_json_object.nama_bendahara_unit"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Bendahara Unit Bisnis {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.nama_bendahara_unit !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider> 
  
  
          <ValidationProvider 
            name="Direktur Utama PT UMB" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Direktur Utama PT UMB
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
              hide-details
  
              v-model="form.template_meta_json_object.nama_direktur"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Direktur Utama PT UMB {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.nama_direktur !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
  
          <ValidationProvider 
            name="Bendahara PT UMB" 
            rules="required" 
            v-slot="{ errors, valid }">
            <div class="body-2 mb-2">
              <span class="red--text">*</span>
              Bendahara PT UMB
              <span class="error--text">
                (wajib diisi)
              </span>
            </div>
            
            <v-text-field
              filled
              rounded
              dense
              :color="set_color"
              
              placeholder="Contoh. Bendahara PT UMB"
              hide-details
  
              v-model="form.template_meta_json_object.nama_bendaara_pt"
              :success="valid"
              :error-messages="errors"
              required
              class="mb-6"
              style="border-radius: 10px;">
              <template v-slot:append-outer>
                <div v-if="errors.length > 0">
                  <v-tooltip top color="#ff5252">
                    <template v-slot:activator="{ on }">
                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    
                    Bendahara PT UMB {{ errors[0] }}
                  </v-tooltip>
                </div>
  
                <div v-if="form.template_meta_json_object.nama_bendaara_pt !== '' && valid">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
              </template>
            </v-text-field>
          </ValidationProvider>
        </v-col>
  
        <v-col
          cols="12"
          md="6">
          <v-card
            flat
            style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
            <div
              ref="arsippdf"
              style="padding: 50px;">
              <v-card-text
                class="black--text py-2">
                <div class="text-center body-1 font-weight-bold mb-5">
                  MEMO
                </div>
                <v-row>
                  <v-col
                    cols="12"
                    md="7">
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        UNIT BISNIS
                      </v-col>
  
                      <v-col
                        cols="12"
                        md="8"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.unit !== '' ? form.template_meta_json_object.unit : '__________' }}
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        TANGGAL
                      </v-col>
  
                      <v-col
                        cols="12"
                        md="8"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : 
                        <span v-if="form.template_meta_json_object.tanggal !== '' && form.template_meta_json_object.tanggal !== null">
                          {{ form.template_meta_json_object.tanggal | fulldate }}
                        </span>
                        <span v-else>
                          ___________________________
                        </span>
                      </v-col>
                    </v-row>
  
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        LAMP
                      </v-col>
  
                      <v-col
                        cols="12"
                        md="8"
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        : {{ form.template_meta_json_object.lampiran !== '' ? form.template_meta_json_object.lampiran : '__________' }}
                      </v-col>
                    </v-row>
  
                  </v-col>
                </v-row>
                
                <div class="d-flex">
                  <div class="pr-2">
                    Perihal
                  </div>
                  <div>
                    : <span style="font-weight: 500;">{{ form.template_meta_json_object.hal !== '' ? form.template_meta_json_object.hal : '__________' }}</span>
                  </div>
                </div>
  
                <div
                  class="mt-8"
                  style="margin-top: 8px !important;">
  
                  <div
                    class="my-4"
                    style="margin-top: 16px !important; margin-bottom: 16px !important;">
                    <div
                      class=""
                      style="margin-bottom: 16px !important;">
                      Mohon dilakukan Payroll Gaji Karyawan bulan 
                      <span v-if="form.template_meta_json_object.bulan !== '' && form.template_meta_json_object.bulan !== null">
                        {{ form.template_meta_json_object.bulan | fullmonth }}
                      </span>
                      <span v-else>
                        ____________
                      </span>
                      dengan rincian sebagai berikut :
                    </div>
  
                    <div
                      class="mb-4"
                      style="margin-bottom: 16px !important;">
                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0 pr-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Unit Bisnis
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : <span style="font-weight: 500;">{{ form.template_meta_json_object.unit !== '' ? form.template_meta_json_object.unit : '__________' }}</span>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0 pr-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Jumlah Karyawan
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : <span style="font-weight: 500;">{{ form.template_meta_json_object.jumlah_karyawan !== '' ? form.template_meta_json_object.jumlah_karyawan : '__________' }}</span>
                        </v-col>
                      </v-row>


                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0 pr-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Rekening Debet
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : <span style="font-weight: 500;">{{ form.template_meta_json_object.no_rekening !== '' ? form.template_meta_json_object.no_rekening : '__________' }}</span>
                        </v-col>
                      </v-row>


                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0 pr-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Nama Rekening Debet
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : <span style="font-weight: 500;">{{ form.template_meta_json_object.nama_rekening !== '' ? form.template_meta_json_object.nama_rekening : '__________' }}</span>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0 pr-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Total Nominal Transaksi
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : <span style="font-weight: 500;">
                            Rp. 
                            <span v-if="form.template_meta_json_object.total_transaksi !== '' && form.template_meta_json_object.total_transaksi !== null">
                              {{ form.template_meta_json_object.total_transaksi | number }}
                            </span>
                            <span v-else>
                              ___________________________
                            </span>
                          </span>
                        </v-col>
                      </v-row>


                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0 pr-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          Catatan
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0"
                          style="padding-top: 0px !important; padding-bottom: 0px !important;">
                          : <span style="font-weight: 500;">{{ form.template_meta_json_object.catatan !== '' ? form.template_meta_json_object.catatan : '__________' }}</span>
                        </v-col>
                      </v-row>
                    </div>
  
                    <div
                      class="mb-1">
                      Demikian, terima kasih
                    </div>
                  </div>
  
                </div>
  
                <v-row
                  class="mt-8"
                  style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                  <v-col
                    cols="12"
                    md="6"
                    class="text-center"
                    style="text-align: center !important;">
                    <div>
                      Manager Unit Bisnis
                    </div>
  
                    <div class="mt-16">
                      {{ form.template_meta_json_object.nama_manager !== '' ? form.template_meta_json_object.nama_manager : '__________' }}
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="text-center"
                    style="text-align: center !important;">
                    <div>
                      Direktur Utama PT UMB
                    </div>
  
                    <div class="mt-16">
                      {{ form.template_meta_json_object.nama_direktur !== '' ? form.template_meta_json_object.nama_direktur : '__________' }}
                    </div>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                    class="text-center"
                    style="text-align: center !important;">
                    <div>
                      Bendahara Unit Bisnis
                    </div>
  
                    <div class="mt-16">
                      {{ form.template_meta_json_object.nama_bendahara_unit !== '' ? form.template_meta_json_object.nama_bendahara_unit : '__________' }}
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="text-center"
                    style="text-align: center !important;">
                    <div>
                      Bendahara PT UMB
                    </div>
  
                    <div class="mt-16">
                      {{ form.template_meta_json_object.nama_bendaara_pt !== '' ? form.template_meta_json_object.nama_bendaara_pt : '__________' }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
    import { get, post, put, destroy } from "@/service/Axios";
    import { TokenService } from "@/service/Storage.Service";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    import html2pdf from 'html2pdf.js'
  import { ValidationObserver, ValidationProvider } from "vee-validate";
    export default {
      props: {
        form: {
          type: Object,
          default: {}
        },
        units: {
          type: Array,
          default: []
        },
        process: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          picker: {
            expired: false,
            tanggal: false,
            tanggal_mulai: false,
            tanggal_selesai: false,
            tanggal_masuk: false,
  
            range: false
          },
  
          time: {
            pukul: false
          },
        }
      },
      components: {
        
      },
      watch: {
  
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb_soft () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.2)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
  
        // formattedDate: {
        //   get () {
        //     return (this.form.template_meta_json_object.tanggal && this.form.template_meta_json_object.tanggal.length === 10) ? moment(this.form.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.template_meta_json_object.tanggal
        //   },
        //   set (newValue) {
        //     if (newValue && newValue.length == 10) {
        //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
        //         this.form.template_meta_json_object.tanggal = newDate
        //     }
        //   }
        // },
  
        date_range () {
          return this.filter.dates.join(' s/d ')
        }
      },
      mounted () {
        
      },
      methods: {
        add_pegawai () {
          this.form.template_meta_json_object.kepada.push({
            nama: '',
            unit: ''
          })
        },
        add_desc () {
          this.form.template_meta_json_object.deskripsi.push({
            text: ''
          })
        },
        add_tugas () {
          this.form.template_meta_json_object.tugas.push({
            text: ''
          })
        },
        add_kewajiban () {
          this.form.template_meta_json_object.kewajiban.push({
            text: ''
          })
        },
      }
    }
  </script>
  